import React, {useContext} from 'react';
import {Context} from "../../../store/reducer";

/**
 * 可視化4の注意事項ポップアップを再表示するボタン
 * @returns {JSX.Element}
 * @constructor
 */
const Component = () => {
    
    const { state, dispatch } = useContext(Context);

    /**
     * 注意事項ポップアップを閉じる
     */
    const openModal = (e) => {
        dispatch({
            type: 'SET_IS_VIS4_POPUP_OPENED',
            payload: true
        })
        
        e.preventDefault();
    }
    
    return (
      <div className="gnav-foot">
          <div className="gnav-foot__in">
              <a href="#" onClick={openModal}>法規制マップ利用上の注意事項等</a>
          </div>
      </div>
    );
}

export default Component
